import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Permission } from 'src/app/constants/permission.constant';
import { IProduct } from 'src/app/models/products/product';
import { AuthService } from 'src/app/services/auth.service';
import { LabelDataProductCreateComponent } from '../../label-data-product-create/label-data-product-create.component';

@Component({
  selector: 'app-label-data-product-create-action',
  templateUrl: './label-data-product-create-action.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class LabelDataProductCreateActionComponent implements OnInit {
  @Input() selectedProducts: IProduct[] = [];
  @Input() showLabel = false;
  @Output() visibilityDeclared = new EventEmitter<boolean>();

  Permission = Permission;

  constructor(
    public authService: AuthService,
    private dialog: MatDialog,
  ) {}

  get canShow(): boolean {
    return this.authService.hasPermission(Permission.ProductsLabelData);
  }

  ngOnInit(): void {
    Promise.resolve().then(() => this.visibilityDeclared.emit(this.canShow));
  }

  onGenerate(): void {
    this.dialog.open(LabelDataProductCreateComponent, {
      width: '800px',
      maxHeight: '85vh',
      data: {
        productIds: this.selectedProducts.map((p) => p.id!),
        products: this.selectedProducts,
      },
    });
  }
}
